/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Portal_Hero_Mode_LabelInputs */

const en_portal_hero_mode_label = /** @type {(inputs: Portal_Hero_Mode_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`How you train`)
};

const pl_portal_hero_mode_label = /** @type {(inputs: Portal_Hero_Mode_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jak trenujesz`)
};

/**
* | output |
* | --- |
* | "How you train" |
*
* @param {Portal_Hero_Mode_LabelInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const portal_hero_mode_label = /** @type {((inputs?: Portal_Hero_Mode_LabelInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Portal_Hero_Mode_LabelInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_portal_hero_mode_label(inputs)
	return en_portal_hero_mode_label(inputs)
});